import classNames from "classnames/bind";
import PropTypes from "prop-types";
import React from "react";
import style from "./input.module.scss";

const cx = classNames.bind();
const Input = React.forwardRef(
  ({ suffix, prefix, className, ...props }, ref) => {
    return (
      <div className={cx(className, style.Root)}>
        {prefix}
        <input ref={ref} {...props} />
        {suffix}
      </div>
    );
  },
);
Input.propTypes = PropTypes.any.isRequired;
export default Input;
